import { useController, UseControllerProps } from "react-hook-form";

import { ErrorForm } from "./ErrorForm";
import { LabelForm, LabelFormProps } from "./LabelForm";

type InputProps = {
  hidden?: boolean;
  type?: HTMLInputElement["type"];
  placeholder?: string;
  class?: string;
} & UseControllerProps &
  LabelFormProps;

const Input = (props: InputProps) => {
  const { field, fieldState } = useController(props);

  if (!field.value && field.value !== 0 && props.defaultValue) {
    field.value = props.defaultValue;
  }
  return (
    <div className={`w-100 form-input${props?.hidden ? " hidden" : ""}`}>
      <LabelForm
        label={props.label}
        required={!!props.rules?.required}
        labelInfos={props.labelInfos}
      />
      <input
        placeholder={props.placeholder}
        type={props.type || "text"}
        className={`${props.class} form-input_field px-2 ${
          fieldState.error && "form-input_field-error"
        }`}
        {...field}
        disabled={props.disabled || false}
      />
      <ErrorForm error={fieldState.error} />
    </div>
  );
};

export default Input;
